export class AppError extends Error {
  constructor(public override message: string, public statusCode?: number, public originalError?: any) {
    super(message);
    this.name = this.constructor.name;
    // Set prototype explicitly for built-in Error subclassing in TS
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class NetworkException extends AppError {}

export class ApiException extends AppError {}

export class CacheException extends AppError {}

export class ValidationException extends AppError {
  constructor(message: string, public fieldErrors?: Record<string, string>) {
    super(message, 400);
  }
}

export class AuthenticationException extends AppError {
  constructor(message: string, public code?: string) {
    super(message, 401);
  }
}

export class UnauthorizedException extends AuthenticationException {
  constructor(message = 'Unauthorized access') {
    super(message, 'UNAUTHORIZED');
  }
}

export class TokenExpiredException extends AuthenticationException {
  constructor(message = 'Token has expired') {
    super(message, 'TOKEN_EXPIRED');
  }
}

export class NotFoundException extends AppError {
  constructor(message: string) {
    super(message, 404);
  }
}

export class ServerException extends AppError {
  constructor(message: string, statusCode?: number) {
    super(message, statusCode ?? 500);
  }
}

export class TimeoutException extends AppError {
  constructor(message = 'Request timed out') {
    super(message, 408);
  }
}

export class NoInternetException extends AppError {
  constructor(message = 'No internet connection') {
    super(message, 0);
  }
}

export class NeedsVerificationException extends AppError {
  constructor(public email: string, message = 'Email verification is required.') {
    super(message, 403);
  }
}